var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://www.pausentaste.de/","target":"_blank"}},[_c('Logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }